import React, { useEffect, useState, useRef } from 'react';
import Product from '../Products/singleproduct';
import icons from '../../utils/icons.json';
import { useDispatch, useSelector } from 'react-redux';
import fetch from '../../utils/fetch';
import { addTopSellingProducts } from '../../store/topSellingProducts';
import _ from 'lodash';
import PaginationBtn from '../../components/PaginationBtn';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import useScrollTop from '../../hooks/useScrollTop';
import constants from '../../utils/constants.json';
import PriceRange from '../../components/PriceRange';
import SortBy from './SortBy';
import { setBrandsAndColors, sortProducts, filterByBrandsAndColors } from '../../utils/fn';

import banner_2 from '../../assets/banners/banner_3.png';

function TopSelling() {
	useDocumentTitle('Best Sellers');

	const { top } = useScrollTop(window);

	const dispatch = useDispatch();

	const menu = useRef(null);
	const main = useRef(null);

	const products = useSelector((state) => state.topSellingProducts.data);
	const [loadingData, setLoadingData] = useState(false);
	const [loadingError, setLoadingError] = useState('');

	const [brands, setBrands] = useState([]);
	const [colors, setColors] = useState([]);

	const [sortBy, setSortBy] = useState('rand');
	const [brandFilters, setBrandFilters] = useState([]);
	const [colorFilters, setColorFilters] = useState([]);

	const [minPriceRange, setMinPriceRange] = useState(constants.MIN_PRICE);
	const [maxPriceRange, setMaxPriceRange] = useState(constants.MAX_PRICE);

	const [productGroups, setProductGroups] = useState([]);
	const [productsToView, setProductsToView] = useState([]);
	const [viewGroupPosition, setViewGroupPosition] = useState(0);

	useEffect(() => {
		// we will make the menu fixed here
	}, [top]);

	useEffect(() => {
		if (!products) {
			loadData();
		} else {
			setBrandsAndColors(products, setBrands, setColors);
			sortedAndFiltered();
		}
	}, [products]);

	useEffect(() => {
		setProductsToView(productGroups[viewGroupPosition] || []);
	}, [viewGroupPosition, productGroups]);

	useEffect(() => {
		window.scroll({ top: 0, behavior: 'smooth' });
	}, [productsToView]);

	useEffect(() => sortedAndFiltered(), [products, sortBy, colorFilters, brandFilters, brands, colors, minPriceRange, maxPriceRange]);

	function loadData() {
		setLoadingData(true);
		setLoadingError('');
		fetch
			.get('getTopSellingProducts')
			.then((res) => {
				dispatch(addTopSellingProducts(res.list));
				setLoadingData(false);
			})
			.catch((err) => {
				setLoadingData(false);
				setLoadingError(err.message);
			});
	}

	function sortedAndFiltered() {
		let filtered = products;
		if (!filtered) return;
		filtered = filtered.filter((item) => parseFloat(item.itemPrice) >= minPriceRange && parseFloat(item.itemPrice) <= maxPriceRange);
		filtered = filterByBrandsAndColors(filtered, brandFilters, colorFilters);
		filtered = sortProducts(filtered, sortBy);

		setViewGroupPosition(0); // we will check on this
		setProductGroups(filtered);
	}

	function brandFilterAction(val, checked) {
		setBrandFilters((brands) => {
			let arr;
			if (checked) {
				arr = [...brands];
				arr.push(val);
			} else {
				arr = brands.filter((brand) => brand != val);
			}
			return arr;
		});
	}

	function colorFilterAction(val, checked) {
		setColorFilters((colors) => {
			let arr;
			if (checked) {
				arr = [...colors];
				arr.push(val);
			} else {
				arr = colors.filter((color) => color != val);
			}
			return arr;
		});
	}

	return (
		<div className="main-body">
			<h2 className="plain-title">Top Selling Products</h2>
			{/* {<div className="banner" onClick={() => {}} style={{ backgroundImage: `url(${banner_2})` }}></div>} */}

			<div className="products-category">
				<div className="sub-menu sections" ref={menu}>
					<div className="listing">
						<h4>Brand</h4>
						<div className="lists">
							{brands.map((brand, index) => (
								<label className="flex" key={brand.brand + index}>
									<input type="checkbox" onChange={(e) => brandFilterAction(brand.brand, e.target.checked)} />
									<span>{_.upperFirst(brand.brandName)}</span>
								</label>
							))}
							{brands.length === 0 && <label>-</label>}
						</div>
					</div>
					<div className="listing">
						<h4>Colors</h4>
						<div className="lists">
							{colors.map((color, index) => {
								return (
									<label className="flex" key={color.color + index}>
										<input type="checkbox" onChange={(e) => colorFilterAction(color.color, e.target.checked)} />
										<span>{_.upperFirst(color.colorName)}</span>
									</label>
								);
							})}
							{colors.length === 0 && <label>-</label>}
						</div>
					</div>
					<PriceRange
						onRequest={(min, max) => {
							setMinPriceRange(min);
							setMaxPriceRange(max);
						}}
					/>
					<SortBy onSorted={setSortBy} />
				</div>
				<div className="right-side sections">
					{!loadingError && !loadingData && productsToView.length === 0 && <p>There are no products to view</p>}
					{loadingError && <p className="">{loadingError}</p>}
					{loadingData && <div className="waiting" dangerouslySetInnerHTML={{ __html: icons.spinner + '<i>Loading...</i>' }}></div>}
					{productsToView && (
						<>
							<div className="products-view">
								{productsToView.map((product, index) => (
									<Product data={product} key={product.item_code} />
								))}
							</div>
							{productGroups.length > 1 && <PaginationBtn data={{ size: productGroups.length, position: viewGroupPosition, onChange: setViewGroupPosition }} />}
						</>
					)}
				</div>
			</div>
		</div>
	);
}

export default React.memo(TopSelling);
